// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3HVge","content":"RecentSearches_content__15GSY"};